import React from 'react';
import {observer} from 'mobx-react';
import {computed} from 'mobx';
import {MeetingMode} from '@techsee/techsee-common/lib/constants/room.constants';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import get from 'lodash/get';
import Translate from '../translate/Translate';
import {ITsLoaderController} from './ts-loader.controller';
import {TsLoaderController} from '../../../_react_/components/ts-loader/ts-loader.controller';

import './ts-loader.style.scss';

export interface ITsLoaderProps {
    controller: ITsLoaderController;
    requireImage: (imageName: string) => string;
    useNewInterface: boolean;
}

@observer
export class TsLoader extends TechseeBaseComponent<ITsLoaderProps> {
    renderInternal(): JSX.Element {
        const {controller, requireImage, useNewInterface} = this.props;
        const {isConnected, isIE11, dir, loaderText} = controller;

        return (
            <div className={`loader-container ${!isConnected ? 'not-connected' : ''} ${isIE11 ? 'is-ie' : ''}`}>
                {!useNewInterface ? (
                    <div className='ts-loader'>
                        <div className='loader-text' dir={dir}>
                            <Translate text={loaderText} />
                        </div>
                        <img
                            className={!isConnected ? 'not-connected' : ''}
                            src={requireImage('video-preloader.gif')}
                            alt='loading'
                        />
                    </div>
                ) : (
                    <div className='new-loader'>
                        <div className='loader-text' dir={dir}>
                            <Translate text={loaderText} />
                        </div>
                        <img
                            className={!isConnected ? 'not-connected' : ''}
                            src={requireImage('video-preloader-black.gif')}
                            alt='loading'
                        />
                    </div>
                )}
            </div>
        );
    }
}
